import store from '@/store'
import { createClient } from './createClient'

export default createClient({
    baseURL: process.env.VUE_APP_PICA_METRICS_BACKEND,
    getAuthHeader: () => {
        const jwt = store.state.login.jwt
        return jwt ? `Bearer ${jwt}` : null
    },
    refreshAuth: () => store.dispatch('login/refreshJwt', { force: true })
})
